"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG10EDocs = void 0;
var LOG10EDocs = {
  name: 'LOG10E',
  category: 'Constants',
  syntax: ['LOG10E'],
  description: 'Returns the base-10 logarithm of E, approximately equal to 0.434',
  examples: ['LOG10E', 'log(e, 10)'],
  seealso: []
};
exports.LOG10EDocs = LOG10EDocs;